<template>
  <div>
    <p class="font-weight-bold">{{ label }}</p>
    <p>{{ value }}</p>
  </div>
</template>

<script>
export default {
  name: 'Info',
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      required: true,
    },
  },
}
</script>
